<div class="lhs">
   <div class="dashboard-heading">
      @if (simplifiedSelectedDashboard && !isEditing) {
      <span class="dashboard-label">Dashboard</span>
      }
      <ng-container [formGroup]="form">
         <div class="field-container">
            @if (simplifiedSelectedDashboard) { @if (isEditing) {
            <div class="edit-group">
               <span class="editing-pill">
                  <mat-icon>edit</mat-icon>
                  Editing layout
               </span>
               <span class="edit-group_divider" aria-hidden="true"></span>
               <input
                  type="text"
                  class="rename-input"
                  autocomplete="off"
                  formControlName="name"
                  aria-label="Dashboard name"
               />
               <div class="rename-buttons">
                  <button
                     type="button"
                     mat-icon-button
                     matTooltip="Save name"
                     aria-label="Save dashboard name"
                     [disabled]="!(form.valid && form.dirty)"
                     (click)="handleRenameDashboardClick()"
                  >
                     <mat-icon>check</mat-icon>
                  </button>
                  <button
                     type="button"
                     mat-icon-button
                     matTooltip="Undo"
                     aria-label="Undo rename"
                     [disabled]="!form.dirty"
                     (click)="initializeForm()"
                  >
                     <mat-icon>undo</mat-icon>
                  </button>
               </div>
            </div>
            } @else {
            <button
               type="button"
               class="dashboard-switcher"
               [matMenuTriggerFor]="dashboardMenu"
               aria-label="Switch dashboard"
               aria-haspopup="menu"
            >
               <span class="dashboard-switcher_title">{{ simplifiedSelectedDashboard.name }}</span>
               <mat-icon class="dashboard-switcher_chevron">expand_more</mat-icon>
            </button>
            <mat-menu #dashboardMenu="matMenu" class="dashboard-menu" xPosition="after">
               <button mat-menu-item type="button" class="dashboard-menu_create" (click)="handleCreateDashboardClick()">
                  <mat-icon>add</mat-icon>
                  <span>Create dashboard</span>
               </button>
               @for (dashboard of simplifiedDashboards; track dashboard.dashboardId) {
               <button
                  mat-menu-item
                  type="button"
                  class="dashboard-menu_item"
                  [class.is-selected]="isSelectedDashboard(dashboard)"
                  (click)="selectDashboard(dashboard)"
               >
                  <mat-icon class="dashboard-menu_check">check</mat-icon>
                  <span>{{ dashboard.name }}</span>
               </button>
               }
            </mat-menu>
            } }
         </div>
         @if (form.get('name')?.hasError('required')) {
         <mat-error>Dashboard name is required</mat-error>
         } @if (form.get('name')?.hasError('duplicateName')) {
         <mat-error>Please enter a unique dashboard name</mat-error>
         }
      </ng-container>
   </div>
</div>

@if (selectedDashboard) {
<div class="rhs" [class.rhs--editing]="isEditing">
   @if (isEditing) { @if (currentBreakpoint === breakpoints.XSmall || currentBreakpoint === breakpoints.Small) {
   <button mat-raised-button type="button" (click)="toggleIsEditing()">
      <mat-icon>check</mat-icon>
      Done
   </button>
   <button mat-icon-button aria-label="More actions" type="button" matTooltip="More" [matMenuTriggerFor]="actionsMenu">
      <mat-icon>more_vert</mat-icon>
   </button>
   <mat-menu #actionsMenu class="more-actions">
      <button mat-menu-item (click)="openAddTileDialog()">
         <mat-icon>add</mat-icon>
         <span>Add tile</span>
      </button>
      <button mat-menu-item class="menu-item--danger" (click)="handleDeleteDashboardClick()">
         <mat-icon>delete_outline</mat-icon>
         <span>Delete dashboard</span>
      </button>
   </mat-menu>
   } @else {
   <button mat-raised-button type="button" (click)="handleDeleteDashboardClick()">
      <mat-icon>delete_outline</mat-icon>
      Delete dashboard
   </button>
   <button mat-raised-button type="button" (click)="openAddTileDialog()">
      <mat-icon>add</mat-icon>
      Add tile
   </button>
   <button mat-raised-button type="button" (click)="toggleIsEditing()">
      <mat-icon>check</mat-icon>
      Done
   </button>
   } } @else {
   <button mat-raised-button type="button" (click)="toggleIsEditing()">
      <mat-icon>dashboard_customize</mat-icon>
      @if (currentBreakpoint !== breakpoints.XSmall && currentBreakpoint !== breakpoints.Small) { Customize }
   </button>
   }
</div>
}
